module.exports = __webpack_public_path__ + "img/apron.b261f697.png";